import React from 'react';
import PropTypes from 'prop-types';

import { Modal } from '@eb/eds-modal';

import ToSForm from '../../components/newForms/ToSForm';

import './ToSModal.scss';

const ToSSection = ({
    showToS,
    dataTestId = 'tos',
    onCancelToS,
    onAcceptToS,
}) => {
    return (
        <div className="tos-modal" data-testid={dataTestId}>
            <Modal noMinHeight={true} isShown={showToS} onClose={onCancelToS}>
                <div className="eds-l-pad-all-8 eds-align--center">
                    <ToSForm
                        dataTestId={`${dataTestId}-form`}
                        onCancelToS={onCancelToS}
                        onAcceptToS={onAcceptToS}
                    />
                </div>
            </Modal>
        </div>
    );
};

ToSSection.propTypes = {
    dataTestId: PropTypes.string,
    showToS: PropTypes.bool,
    onCancelToS: PropTypes.func,
    onAcceptToS: PropTypes.func,
};

export default ToSSection;
